export const switchStyle = {
  height: '22px',
  width: '47px',
  padding: '0px',
  borderRadius: '18px',
  '&.MuiSwitch-track': {
    height: '22px',
    width: '47px',
    backgroundColor: '#8E8E8E',
    boxSizing: 'border-box',
  },
  '& .MuiSwitch-thumb': {
    margin: '-7px 0px 0px -7px',
    width: 18,
    height: 18,
    transition: '0.1s ease-out',
  },
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      transform: 'translateX(25px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#009FDA',
        opacity: 1,
      },
    },
  },
}
